import React, { Component } from "react";
import { Button, Image } from "react-bootstrap";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Form from "react-bootstrap/Form";

import { PopupActionButton } from "../buttonReusableComponent/ButtonReusableComponent";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { send_notification_diner } from "../../../store/actions/notificationAction/notificationActions";
import isEmpty from "../../../store/validation/is-Empty";
import { NewInputText } from "../inputReusableComponent/InputBoxComponent";

export class NotificationButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      name: "",
      diner_id: "",
      sendNotification: "",
      hasSetNotificationProps: false,
      error: "",
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.dataSend) && !nextState.hasSetSmsProps) {
      return {
        name: !isEmpty(nextProps.dataSend.user_details.name)
          ? nextProps.dataSend.user_details.name
          : "",
        diner_id: !isEmpty(nextProps.dataSend._id)
          ? nextProps.dataSend._id
          : "",
        hasSetNotificationProps: true,
      };
    }
    return null;
  }

  onChange = (e) => {
    this.setState({
      error: "",
      [e.target.name]: e.target.value,
    });
  };

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.sendNotification === "") {
      var errorMsg = "Please Enter Notification";
      this.setState({ error: errorMsg });
    } else {
      const token = this.props.auth?.user?.accessToken;
      if (this.props.actionBy === "RsvpEvent") {
        const formData = {
          event_request_id: this.state.diner_id,
          message: this.state.sendNotification,
          type: 2,
        };
        this.props.send_notification_diner(formData, token, this.onSuccess);
      } else {
        const formData = {
          diner_id: this.state.diner_id,
          message: this.state.sendNotification,
          type: 0,
        };
        this.props.send_notification_diner(formData, token, this.onSuccess);
      }
    }
  };

  onSuccess = (e) => {
    this.setState({
      sendNotification: "",
    });
    this.onCloseModal();
  };

  render() {
    const { open, name } = this.state;
    return (
      <div>
        {/* <PopupIconButtonReusable
          buttonClass={this.props.buttonClass}
          titleText="Push Notification"
          image={require("../../../assets/images/ActionImages/ring.svg")}
          onClick={this.onOpenModal}
        /> */}
        <Button
          variant="link"
          className="enIconBtn mr-3"
          onClick={this.onOpenModal}
        >
          <Image
            src={require("../../../assets/images/UserManagement/notification.svg")}
            alt="Notification"
            title="Send Notification"
            fluid
          />
        </Button>
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "customModal-calling-action",
            closeButton: "customCloseButtonCalling",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="p-4">
            <div className="d-flex justify-content-between">
              <div className="f20_700_HelveticaNeue">Push Notification</div>
              <div className="cursor" onClick={this.onCloseModal}>
                <Image
                  src={require("../../../assets/images/UserManagement/close.svg")}
                  alt="Call"
                  title="Calling Button"
                  fluid
                />
              </div>
            </div>
            <div className="f14-400 text-dark py-3">
              Do you want to send notification {name}?
            </div>
            <div className="pt-4">
              <Form noValidate onSubmit={this.handleSubmit}>
                <NewInputText
                  labelText="Add Comments"
                  extraClass="mb-2 w-100"
                  multiline={true}
                  rows="5"
                  onChange={this.onChange}
                  name="sendNotification"
                  value={this.state.sendNotification}
                />
                <div className="f10-400 text-red">{this.state.error}</div>
                <div className="d-flex align-items-center py-3 mt-2">
                  <div className="mr-3">
                    <PopupActionButton
                      buttonText="Cancel"
                      buttonType="button"
                      buttonClass="noButton"
                      onClick={this.onCloseModal}
                    />
                  </div>
                  <PopupActionButton
                    buttonText="Send"
                    buttonType="Submit"
                    buttonClass="yesButton"
                  />
                </div>
              </Form>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

NotificationButton.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  send_notification_diner,
})(withRouter(NotificationButton));
